/**
 * What a teacher keeps in this browser, filed under her id. A shared school PC has one browser
 * and several teachers, so a bare key shows the last teacher's class lists to the next one.
 * Every such key is `<name>:<teacherId>`; signing out calls `forgetTeacher`, which removes them
 * all without having to know which features keep any.
 */
export const teacherKey = (name: string, teacherId: string) => `${name}:${teacherId}`

export function forgetTeacher(teacherId: string): void {
	try {
		const suffix = `:${teacherId}`
		const mine: string[] = []
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i)
			if (key?.startsWith('tt-') && key.endsWith(suffix)) mine.push(key)
		}
		for (const key of mine) localStorage.removeItem(key)
	} catch {
		// Storage blocked: nothing was kept.
	}
}

/**
 * A guest has just been merged into an account: what she kept in this browser under the guest's id
 * moves to the account's id, so her class lists come with her work. An account that already keeps
 * the same thing here wins; the guest's copy is removed either way, so no orphan is left behind.
 */
export function moveTeacherData(from: string, to: string): void {
	if (from === to) return
	try {
		const suffix = `:${from}`
		const mine: string[] = []
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i)
			if (key?.startsWith('tt-') && key.endsWith(suffix)) mine.push(key)
		}
		for (const key of mine) {
			const value = localStorage.getItem(key)
			const target = `${key.slice(0, -suffix.length)}:${to}`
			if (value !== null && localStorage.getItem(target) === null)
				localStorage.setItem(target, value)
			localStorage.removeItem(key)
		}
	} catch {
		// Storage blocked: nothing was kept.
	}
}
